<template>
  <div class="facilities">
    <section class="container">
      <div class="goodsList" v-for="item in facilityList" :key="item.id">
        <el-image fit="cover" class="goods_img" :src="item.coverImage" />
        <div class="goods_detail">
          <div class="detail_right">
            <div class="detail_title">
              <div class="detail_title_text">{{ item.title }}</div>
              <el-image v-if="item.logoImage" :src="item.logoImage" fit="cover" class="logo" >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
            <div class="conference_entitle contentTag">{{ item.contentNoTag }}</div>
            <div class="mobile">
              <div class="mobile_left">
                <img src="../../assets/img/facilities/dh.png" />
                <span>{{ item.telNotag }}</span>
                <img src="../../assets/img/facilities/mail.png" style="margin-left: 30px" />
                <span>{{ item.email }}</span>
<!--                <span @click="checkMobile(item.tel)">查看 Check</span>-->
              </div>
              <el-button type="primary" class="detail" @click="toDetails(item.id)">详情 Detail</el-button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="container">
      <TablePage ref="list" @page-change="getMeetingList" :total="total" :pageSizeNum="3"> </TablePage>
    </section>
    <FacilitiesDialog
      :visible.sync="facilitiesVisible"
      title=""
      :facilitiesData="facilitiesData"
      :isShow="isShow"
    ></FacilitiesDialog>
  </div>
</template>

<script>
import Nav from "@/components/base/Nav.vue";
import FacilitiesDialog from "./components/FacilitiesDialog.vue";
import TablePage from "@/components/base/TablePage";
export default {
  name: "facilities",
  components: { FacilitiesDialog, TablePage, Nav },
  data() {
    return {
      capacity: [
        { value: "不限", userCountType: 0 },
        { value: "30以下", userCountType: 1 },
        { value: "30-60", userCountType: 2 },
        { value: "60-100", userCountType: 3 },
        { value: "100-200", userCountType: 4 },
        { value: "200-300", userCountType: 5 },
        { value: "300-400", userCountType: 6 },
        { value: "400-500", userCountType: 7 },
        { value: "500以上", userCountType: 8 },
      ],
      acreage: [
        { value: "不限", areaType: 0 },
        { value: "60m²以下", areaType: 1 },
        { value: "60m²-100m²", areaType: 2 },
        { value: "100m²-150m²", areaType: 3 },
        { value: "150m²-200m²", areaType: 4 },
        { value: "200m²-300m²", areaType: 5 },
        { value: "300m²-400m²", areaType: 6 },
        { value: "400m²-500m²", areaType: 7 },
        { value: "500m²-1000m²", areaType: 8 },
        { value: "1000m²以上", areaType: 9 },
      ],
      corollary: [
        {
          chName: "WIFI",
          enName: "",
          value: "hasWifi",
          checked: 0,
          img: require("@/assets/img/facilities/wifi.png"),
        },
        {
          chName: "电视",
          enName: "Television",
          value: "hasTv",
          checked: 0,
          img: require("@/assets/img/facilities/ds.png"),
        },
        {
          chName: "LED屏",
          enName: "LED",
          value: "hasLed",
          checked: 0,
          img: require("@/assets/img/facilities/led.png"),
        },
        {
          chName: "投影仪",
          enName: "Projectors",
          value: "hasHdr",
          checked: 0,
          img: require("@/assets/img/facilities/tyx.png"),
        },
        {
          chName: "麦克风",
          enName: "Microphones",
          value: "hasMic",
          checked: 0,
          img: require("@/assets/img/facilities/mkf.png"),
        },
      ],
      activeValue: "2",
      userCountType: 0, //容纳人数
      areaType: 0, //面积
      total: 0,
      meetingList: [], //会议列表
      facilityList: [], //其他设施列表
      facilitiesData: {},
      facilitiesVisible: false,
      isShow: false,
    };
  },
  props: {},
  computed: {},
  async mounted() {
    this.searchHandler();
  },
  methods: {
    onChange(val) {
      this.getMeetingList(1, 3);
    },
    //初始化查询
    searchHandler() {
      this.$refs.list.reset();
    },
    async getMeetingList(page, pageSize) {
      //其他设施
      const params = {
        page: page,
        pageSize: pageSize,
      };
      try {
        let {
          data: { list, total },
        } = await this.$api.getFacilityList(params);
        this.facilityList = (list || []).map((item) => {
          item.contentNoTag = this.removeTAG(item.content);
          this.regReplace(item);
          return item;
        });
        this.total = total;
      } catch (error) {
        console.log(error);
      }
    },
    regReplace(data) {
      let reg = /^(\d{3})\d{4}(\d{4})$/;
      let regExp = /\d{3}$/;
      if (data.tel.indexOf("-") == -1) {
        //.replace(reg, "$1****$2")
        data.telNotag = data.tel;
      } else {
        //.replace(regExp, "***")
        data.telNotag = data.tel;
      }
    },
    async getMeetingDetail(id) {
      const params = {
        id: id,
      };
      try {
        let { data } = await this.$api.getMeetingDetail(params);
        let facilitiesData = data || {};
        facilitiesData.imgList = (facilitiesData.images || "").split(",");
        facilitiesData.hotelServiceDesc = [
          {
            titleCh: "免费特供",
            titleEn: "Includes",
            descCh: `${facilitiesData.hasTea == 1 ? "茶水*" + facilitiesData.teaNum : ""}${
              facilitiesData.hasFruit == 1 ? "/果盘*" + facilitiesData.fruitNum : ""
            }`,
            descEn: `${facilitiesData.hasTea == 1 ? "Tea*" + facilitiesData.teaNum : ""}${
              facilitiesData.hasFruit == 1 ? "/fruit Bowl*" + facilitiesData.fruitNum : ""
            }`,
            show: facilitiesData.hasTea == 1 || facilitiesData.hasFruit == 1,
          },
          {
            titleCh: "餐标",
            titleEn: "Price",
            descCh: `${facilitiesData.mealPrice + "/人"}`,
            descEn: `${facilitiesData.mealPrice + " per person"}`,
            show: Boolean(facilitiesData.mealPrice),
          },
          {
            titleCh: "计费单位",
            titleEn: "Unit of account",
            descCh: facilitiesData.minTimeUnit == 0 ? "小时" : "天",
            descEn: facilitiesData.minTimeUnit == 0 ? "Hours" : "Days",
            show: true,
          },
          {
            titleCh: "起订时长",
            titleEn: "Minimum Duration",
            descCh: `${facilitiesData.minTime}${facilitiesData.minTimeUnit == 0 ? "小时" : "天"}`,
            descEn: `${facilitiesData.minTime}${facilitiesData.minTimeUnit == 0 ? " Hours" : " Days"}`,
            show: facilitiesData.minTime ? true : false,
          },
        ];
        this.facilitiesData = facilitiesData;
      } catch (error) {
        console.log(error);
      }
    },
    async getFacilityDetail(id) {
      const params = {
        id: id,
      };
      try {
        let { data } = await this.$api.getFacilityDetail(params);
        let facilitiesData = data || {};
        facilitiesData.imgList = (facilitiesData.coverImage || "").split(",");
        facilitiesData.content = facilitiesData.content.replace(/img/g, 'img class="descClauseImg"');
        this.facilitiesData = facilitiesData;
      } catch (error) {
        console.log(error);
      }
    },
    removeTAG(str) {
      return str.replace(/<[^>]+>/g, "").replace(/&nbsp;/g,"");
    },
    numSelect(val, type) {
      if (type == "capacity") {
        this.userCountType = val;
      } else if (type == "acreage") {
        this.areaType = val;
      } else if (type == "corollary") {
        this.corollary.map((item, index) => {
          if (val == index) {
            item.checked = item.checked == 0 ? 1 : 0;
          }
          return item;
        });
      }
      this.getMeetingList(1, 3);
    },
    toDetails(id) {
      if (this.activeValue == "1") {
        this.getMeetingDetail(id);
        this.isShow = false;
      }
      if (this.activeValue == "2") {
        this.getFacilityDetail(id);
        this.isShow = true;
      }
      this.facilitiesVisible = true;
    },
    checkMobile(tel) {
      this.$alert(tel, "", {});
    },
  },
};
</script>

<style lang="scss" scoped>
.channel_nav_container {
  margin: 74px 0 0 39px;
}
.change_box {
  margin: 50px 0 0 39px;
}
.ellipsis {
  padding: 29px 0;
  border-bottom: 1px solid #efeff4;
  display: flex;
  align-items: center;
}
.ellipsis_left {
  font-size: 14px;

  font-weight: 400;
  color: #333333;
  padding-right: 35px;
  border-right: 1px solid #efeff4;
  flex: none;
}
.ellipsis_right {
  margin-left: 14px;
  display: flex;
  flex-flow: wrap;
}
.selected_item {
  padding: 8px 15px;
  font-size: 14px;

  font-weight: 400;
  color: #333333;
  margin-right: 16px;
  cursor: pointer;
}
.goodsList {
  width: 1200px;
  height: 358px;
  margin-top: 60px;
  position: relative;
}
.goods_img {
  width: 328px;
  height: 328px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}
.selectItem {
  padding: 8px 15px;
  font-size: 14px;

  font-weight: 400;
  color: #ffffff;
  background: #333333;
  margin-right: 16px;
  cursor: pointer;
}
.goods_detail {
  width: 1159px;
  height: 358px;
  background: #ffffff;
  box-shadow: 0px 6px 40px 0px rgba(204, 204, 204, 0.3);
  position: absolute;
  top: 0;
  right: 0;
  .detail_right {
    height: 328px;
    margin-left: 328px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding-right: 40px;
    .detail_title {
      display: flex;
      display: -webkit-flex;
      display: -o-flex;
      display: -ms-flex;
      display: -moz-flex;
      .detail_title_text{
        width: 100%;
        font-size: 18px;
        font-weight: 400;
        color: #333333;
        padding-bottom: 39px;
        border-bottom: 1px solid #f0f0f0;
        flex-shrink: 1;
        -webkit-flex-shrink: 1;
      }
      .logo{
        width: auto;
        height: 80px;
        margin-left: 15px;
      }
    }
    .conference_entitle {
      display: flex;
      flex-wrap: wrap;
      line-height: 60px;
      .conference_img {
        display: flex;
        align-items: center;
        margin-right: 60px;
        img {
          width: 22px;
          height: auto;
          margin-right: 20px;
        }
        span {
          font-size: 14px;

          font-weight: 400;
          color: #333333;
        }
      }
    }
    .contentTag {
      line-height: 30px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;
    }
    .mobile {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .mobile_left {
        display: flex;
        align-items: center;
        img {
          width: 22px;
          height: 22px;
          margin-right: 19px;
        }
        span {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          &:nth-child(3) {
            margin-left: 30px;
            cursor: pointer;
          }
        }
      }
      .detail {
        width: 152px;
        height: 40px;
        background: #333333;
        font-size: 14px;

        font-weight: 400;
        color: #ffffff;
      }
    }
  }
}
</style>
